import { render, staticRenderFns } from "./CreateRule.vue?vue&type=template&id=d356cc3e"
import script from "./CreateRule.vue?vue&type=script&lang=js"
export * from "./CreateRule.vue?vue&type=script&lang=js"
import style0 from "./CreateRule.vue?vue&type=style&index=0&id=d356cc3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports